import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=4046fac5&scoped=true&"
import script from "./resource.vue?vue&type=script&lang=js&"
export * from "./resource.vue?vue&type=script&lang=js&"
import style0 from "./resource.vue?vue&type=style&index=0&id=4046fac5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4046fac5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4046fac5')) {
      api.createRecord('4046fac5', component.options)
    } else {
      api.reload('4046fac5', component.options)
    }
    module.hot.accept("./resource.vue?vue&type=template&id=4046fac5&scoped=true&", function () {
      api.rerender('4046fac5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resource/resource.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/resource/resource.vue
// module id = 0phI
// module chunks = 0